import { render, staticRenderFns } from "./RedPacketUploadImg.vue?vue&type=template&id=2e2d14bf&scoped=true"
import script from "./RedPacketUploadImg.vue?vue&type=script&lang=js"
export * from "./RedPacketUploadImg.vue?vue&type=script&lang=js"
import style0 from "./RedPacketUploadImg.vue?vue&type=style&index=0&id=2e2d14bf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d14bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2d14bf')) {
      api.createRecord('2e2d14bf', component.options)
    } else {
      api.reload('2e2d14bf', component.options)
    }
    module.hot.accept("./RedPacketUploadImg.vue?vue&type=template&id=2e2d14bf&scoped=true", function () {
      api.rerender('2e2d14bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketUploadImg.vue"
export default component.exports